const queryString = require('qs');

const paramsToString = (params) => {
    const res = queryString.stringify(params, { arrayFormat: 'brackets' });
    return `&${res}`;
};

export default paramsToString;
